import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  AssetRegisterReport,
  DepreciationScheduleRow,
  TieOutReport,
} from '../interfaces/fixedAsset/fixedAssetReport.interface';

export const FixedAssetReportService = {
  register: async (institutionId: string, asOf: string): Promise<AssetRegisterReport> =>
    (await axios.get(`${ENDPOINTS.FIXED_ASSET_REPORT.REGISTER(institutionId)}?asOf=${asOf}`)).data,
  schedule: async (institutionId: string, from: string, to: string): Promise<DepreciationScheduleRow[]> =>
    (await axios.get(`${ENDPOINTS.FIXED_ASSET_REPORT.SCHEDULE(institutionId)}?from=${from}&to=${to}`)).data,
  tieOut: async (institutionId: string, asOf: string): Promise<TieOutReport> =>
    (await axios.get(`${ENDPOINTS.FIXED_ASSET_REPORT.TIE_OUT(institutionId)}?asOf=${asOf}`)).data,
};
